
<script>
    import { onMount } from "svelte";
    import { Authentication } from '../stores'
    import Fa from 'svelte-fa'
    import { faBasketShopping } from '@fortawesome/free-solid-svg-icons'
    import CheeseOrderMgt from '../components/CheeseOrderMgt.svelte'

    let modal;
    let authenthicationData = '';

    export let customer = '';
    
    onMount(async function () {});

    function clickExecuted() {
        modal.show();
    }

    function loadCheeseData() {
        loadCheeseCountOpenOrders();
    }

    async function loadCheeseCountOpenOrders() {
        await Authentication.subscribe((data) => authenthicationData = data);
        
        let url = 'MYURL/CheeseCountCustomerIdOpenOrders/' + customer.id;
        
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        customer.cheeseCount_OpenOrders = data;
    }
</script>

<div class="IconOrder" on:click={clickExecuted}>
    <Fa icon={faBasketShopping} on:clicked={clickExecuted}/>
</div>
<div class="TextOrder" on:click={clickExecuted}>
    {customer.cheeseCount_OpenOrders} In Bestellung
    {#if customer.cheeseCount_OpenOrdersMatured > 0}
        <b style='color:red;'>({customer.cheeseCount_OpenOrdersMatured})</b>
    {/if}&nbsp;&nbsp;&nbsp;
</div>
<CheeseOrderMgt bind:this={modal} customer={customer} on:accepted={loadCheeseData}/>

<style>
    .IconOrder {
        padding-right: 10px;
        cursor: pointer;
        color: blue;
    }
    
    .TextOrder {
        cursor: pointer;
    }
</style>